import React, { useMemo, useState, useContext } from 'react';
import { useIdleTimer } from 'react-idle-timer';

import { SocketContext } from 'context/SocketContext';

export const IdleContext = React.createContext();

const IDLE_TIME = 1000 * 60 * 10; // 10 mins

export const IdleProvider = ({ children }) => {
    const sockets = useContext(SocketContext)
    const [isIdle, setIsIdle] = useState(false);

    const handleOnIdle = event => {
        setIsIdle(true);
        
        sockets?.emitEvent('user_inactive');
    }

    const handleOnActive = event => {
        setIsIdle(false);
        sockets?.emitEvent('user_active');
    }

    useIdleTimer({
        timeout: IDLE_TIME,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        debounce: 500
    })

    const value = useMemo(() => ({
        isIdle
    }), [isIdle]);

    return (
        <IdleContext.Provider value={value}>
            { children }
        </IdleContext.Provider>
    )
};
